<template>
	<a :href="url" target="_blank" rel="noopener noreferrer">
		<slot />
	</a>
</template>

<script setup lang="ts">
import BookingEngine, { type BookingParameters } from '@becurioushq/lighthouse';

const { locale } = useI18n();
const props = defineProps<BookingParameters>();

const bookingEngine = useState<BookingEngine | null>('bookingEngine', () => null);

const url = computed(() => {
	if (!bookingEngine.value) {
		return '#';
	}

	return bookingEngine.value.getUrl({ ...props, language: props.language || locale.value });
});

onMounted(() => {
	if (!bookingEngine.value) {
		bookingEngine.value = new BookingEngine({
			hotelID: 'hotel-wesseling-dwingeloo',
		});
	}
});
</script>

<style lang="scss" scoped>
a {
	color: #fff;
	cursor: pointer;

	&:hover {
		text-decoration: none;
	}
}
</style>
